import { PackageItemV2, PackageObjV2, PackagesPageV2 } from '@grandstand/presentation-models'

export type PackageDataResult = {
  variant_type: 'monthly' | 'annual' | 'seasonal'
  purchase_option: PackageItemV2
  package: PackageObjV2
}

export function findPackageDataByServiceId(
  pkg: PackageObjV2 | PackageObjV2[],
  serviceId: string
): PackageDataResult | undefined {
  const packages = Array.isArray(pkg) ? pkg : [pkg]
  for (const packageItem of packages) {
    const entry = Object.entries(packageItem.purchase_options).find(
      ([_, purchase_option]) => purchase_option?.service_id === serviceId
    )

    if (entry) {
      const [variant_type, purchase_option] = entry
      return {
        variant_type: variant_type as 'monthly' | 'annual' | 'seasonal',
        purchase_option,
        package: packageItem,
      }
    }
  }
  return undefined
}

export function getAllPackagesFromPage(packagesPage: PackagesPageV2): PackageObjV2[] {
  return [
    ...packagesPage.available_bundles,
    ...packagesPage.available_packages,
    ...packagesPage.available_seasonal_packages,
  ]
}
